/**
 * Mock implementation of @capacitor/local-notifications
 * Used for web environments where the real module isn't available
 */
import logger from '../../utils/logger';

export interface PermissionState {
  display: 'granted' | 'denied' | 'prompt';
}

export interface LocalNotification {
  id: number;
  title: string;
  body: string;
  schedule?: { at: Date };
  sound?: string;
  actionTypeId?: string;
  extra?: Record<string, any>;
}

export interface NotificationChannel {
  id: string;
  name: string;
  description?: string;
  sound?: string;
  visibility?: string;
  importance?: number;
  lights?: boolean;
  vibration?: boolean;
}

const LocalNotifications = {
  async checkPermissions(): Promise<{ display: 'granted' | 'denied' | 'prompt' }> {
    return { display: 'granted' };
  },

  async requestPermissions(): Promise<{ display: 'granted' | 'denied' | 'prompt' }> {
    return { display: 'granted' };
  },

  async schedule(options: { notifications: LocalNotification[] }): Promise<{ notifications: LocalNotification[] }> {
    logger.info('[Mock] Scheduling notifications:', options.notifications);
    return { notifications: options.notifications };
  },

  async cancel(options: { notifications: { id: number }[] }): Promise<void> {
    logger.info('[Mock] Cancelling notifications:', options.notifications);
  },

  async getPending(): Promise<{ notifications: LocalNotification[] }> {
    return { notifications: [] };
  },

  async registerActionTypes(options: { types: any[] }): Promise<void> {
    logger.info('[Mock] Registering action types:', options.types);
  },

  async createChannel(channel: NotificationChannel): Promise<void> {
    logger.info('[Mock] Creating channel:', channel);
  },

  async deleteChannel(id: string): Promise<void> {
    logger.info('[Mock] Deleting channel:', id);
  },

  async listChannels(): Promise<{ channels: NotificationChannel[] }> {
    return { channels: [] };
  }
};

export { LocalNotifications };